<template>
  <div>
    <p class="auto-url-parser" @click="handleClick">
      <i class="el-icon-edit" />
      <span>智能作品信息填写</span>
    </p>

    <el-dialog
      v-if="showDialog"
      title="智能作品信息填写"
      :visible.sync="showDialog"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
    >
      <slot name="tip">
        <p style="margin-bottom: 10px;">请粘贴包含<b>作品链接</b>的信息</p>
      </slot>
      <el-input
        type="textarea"
        :rows="rows"
        v-model="content"
        :placeholder="placeholder"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AutoParser',
  props: {
    placeholder: {
      type: String,
      default: '请在这里直接粘贴包含作品链接信息，可自动识别歌曲各种信息'
    },
    rows: {
      type: Number,
      default: 6
    },
    defaultContent: String
  },
  data() {
    return {
      showDialog: false,
      content: ''
    }
  },
  created() {
    if (this.defaultContent) {
      this.content = this.defaultContent
    }
  },
  methods: {
    handleClick() {
      this.showDialog = true
    },
    handleClose() {
      this.showDialog = false
    },
    handleSubmit() {
      if (!this.content) {
        this.$message.warning('请填入相关智能作品信息')
        return
      }

      this.$emit('submit', this.content)
      this.handleClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.auto-url-parser {
  display: inline-block;
  margin-left: 24px;
  transform: scale(0.9);
  cursor: pointer;
}
</style>
